import { createStyles } from "@mantine/core";

import DialogBody from "~/domains/design-system/components/Dialog/DialogBody/DialogBody";
import { Title } from "~/domains/design-system/Title";

const useStyles = createStyles((theme) => ({
  body: {
    maxWidth: 480,
    width: '100vw',
  },
  title: {
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: `0 ${theme.other.spacing._32}px`,
  },
  subtitle: {
    textTransform: 'uppercase',
    textAlign: 'center',
    margin: '16px auto 0',
    padding: `0 ${theme.other.spacing._32}px`,
    color: theme.colors.gray2[3],
  },
  list: {
    listStyleType: 'none',
    counterReset: 'item',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },
  listItem: {
    display: 'flex',
    gap: theme.other.spacing._16,

    '&:before': {
      width: theme.other.spacing._48,
      height: theme.other.spacing._48,
      background: theme.colors.gray2[0],
      color: theme.colors.gray2[6],
      borderRadius: '50%',
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      content: 'counter(item)',
      counterIncrement: 'item',
    },
  },
  delimiter: {
    margin: `${theme.other.spacing._32}px 0 ${theme.other.spacing._16}px`,
    borderTop: `1px dashed ${theme.colors.gray2[1]}`,
  },
}));

type ChildrenProps = {
  children: React.ReactNode;
};
export function ContestManageModalBody({ children }: ChildrenProps) {
  const { classes } = useStyles();

  return <DialogBody className={classes.body}>{children}</DialogBody>;
}

export function ContestManageModalTitle({ children }: ChildrenProps) {
  const { classes } = useStyles();

  return (
    <Title variant="display-headline-expanded-xl" className={classes.title}>
      {children}
    </Title>
  );
}

export function ContestManageModalOrderedList({ children }: ChildrenProps) {
  const { classes } = useStyles();

  return <ol className={classes.list}>{children}</ol>;
}

export function ContestManageModalOrderedListItem({ children }: ChildrenProps) {
  const { classes } = useStyles();

  return <li className={classes.listItem}>{children}</li>;
}

export function ContestManageModalDelimiter() {
  const { classes } = useStyles();

  return <div className={classes.delimiter} />;
}
